export default __webpack_public_path__ + "b03f86e24163d8432f3b713cd9618de7.svg";